import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import { FiltersFormGroup } from 'system/pages/groups/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersGroupProps {
  filterGroupForm: FormikProps<FiltersFormGroup>;
}

const FiltersGroup = ({ filterGroupForm }: FiltersGroupProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-groups-content"
        id="panel-groups-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterGroupForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Identificativo gruppo"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterGroupForm.values.code}
                onChange={filterGroupForm.handleChange}
                error={filterGroupForm.touched.code && Boolean(filterGroupForm.errors.code)}
                helperText={filterGroupForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione gruppo"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterGroupForm.values.description}
                onChange={filterGroupForm.handleChange}
                error={
                  filterGroupForm.touched.description && Boolean(filterGroupForm.errors.description)
                }
                helperText={filterGroupForm.errors.description}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterGroupForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersGroup.displayName = 'Filters Group component';

export default FiltersGroup;
